<template>
  <div>
    <!-- Barra de atalho para modo de edição -->
    <div
      v-if="$route.params.id"
      class="d-flex flex-wrap justify-content-between align-items-center mb-2 p-1 bg-white rounded shadow-sm border"
    >
      <div class="d-flex align-items-center mb-50 mb-sm-0">
        <b-badge
          variant="light-primary"
          class="mr-1 py-50 px-1 font-weight-bolder"
        >
          EDIÇÃO
        </b-badge>
        <span class="text-muted small">
          Navegue clicando diretamente nas etapas à esquerda ou use o atalho rápido:
        </span>
      </div>
      <b-button
        size="sm"
        variant="primary"
        @click="irParaCronograma"
      >
        <feather-icon
          icon="CalendarIcon"
          class="mr-50"
        />
        Ir para Desafios & Cronograma
      </b-button>
    </div>

    <form-wizard
      ref="wizard"
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Finalizar"
      back-button-text="Anterior"
      next-button-text="Próximo"
      class="wizard-vertical mb-3"
      @on-complete="formSubmitted"
    >
      <!-- account datails tab -->
      <tab-content title="Dados da Escola">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Dados da Escola
            </h5>
            <small class="text-muted"> Insira os dados da Escola </small>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Nome da Escola"
              label-for="v-username"
            >
              <b-form-input
                id="v-username"
                v-model="form.name"
                placeholder="Insira o nome aqui"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="E-mail"
              label-for="v-email"
            >
              <b-form-input
                id="v-email"
                v-model="form.email"
                type="email"
                placeholder="exemplo@email.com"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Telefone"
              label-for="v-username"
            >
              <b-form-input
                id="v-username"
                v-model="form.telephone"
                placeholder="Insira o número aqui"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label-for="v-greId"
              label="Gerência Regional de Educação (GRE)"
            >
              <v-select
                id="greId"
                v-model="form.greId"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :selectable="option => option.value != null"
                :options="greOptions"
                label="text"
              >
                <template #no-options="{ searching }">
                  <span v-if="searching">Nenhum resultado encontrado.</span>
                  <span v-else>Ops! Lista vazia.</span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Ponto de Coleta">
              <b-form-checkbox
                v-model="form.existePontoColeta"
                switch
              >
                Escola possui ponto de coleta
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content title="Diretoria">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Diretoria
            </h5>
            <small class="text-muted">Insira as informações do Diretor</small>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Nome do Diretor"
              label-for="v-first-name"
            >
              <b-form-input
                id="v-first-name"
                v-model="form.nameDirector"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="E-mail"
              label-for="v-last-name"
            >
              <b-form-input
                id="v-last-name"
                v-model="form.emailDirector"
                placeholder=""
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="CPF"
              label-for="v-last-name"
            >
              <b-form-input
                id="v-last-name"
                v-model="form.cpfDirector"
                placeholder=""
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Celular"
              label-for="v-last-name"
            >
              <b-form-input
                id="v-last-name"
                v-model="form.cellPhoneDirector"
                placeholder=""
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- address -->
      <tab-content title="Endereço">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Endereço
            </h5>
            <small class="text-muted">Insira os dados sobre localização</small>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Endereço"
              label-for="v-address"
            >
              <b-form-input
                id="v-address"
                v-model="form.address"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Bairro"
              label-for="v-landmark"
            >
              <b-form-input
                id="v-landmark"
                v-model="form.neighborhood"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="CEP"
              label-for=""
            >
              <b-form-input
                id="v-pincode"
                v-model="form.postalCode"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Cidade"
              label-for="v-city"
            >
              <b-form-input
                id="v-city"
                v-model="form.city"
                placeholder=""
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- cronograma de desafios tab -->
      <tab-content title="Desafios & Cronograma">
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Controle e Cronograma de Desafios
            </h5>
            <small class="text-muted">Configure a ativação e os períodos em que os desafios ficarão disponíveis para os alunos no aplicativo mobile.</small>
          </b-col>
        </b-row>

        <!-- Card Coleta e Reciclagem -->
        <b-row class="mb-2 p-1 border rounded bg-light">
          <b-col
            cols="12"
            class="mb-1"
          >
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <h6 class="text-primary font-weight-bold mb-25">
                  Desafio: Coleta e Reciclagem
                </h6>
                <small class="text-muted">Libera a execução da etapa de pesagem e descarte de recicláveis no aplicativo.</small>
              </div>
              <b-form-checkbox
                v-model="form.coletaAtiva"
                switch
                class="custom-control-primary"
              >
                {{ form.coletaAtiva ? 'Desafio Ativado' : 'Desafio Desativado' }}
              </b-form-checkbox>
            </div>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Data de Início da Coleta"
              label-for="coletaDataInicio"
            >
              <flat-pickr
                id="coletaDataInicio"
                v-model="form.coletaDataInicio"
                class="form-control"
                :config="configFlatPickr"
                placeholder="Ex: 01/10/2026"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Data de Término da Coleta"
              label-for="coletaDataFim"
            >
              <flat-pickr
                id="coletaDataFim"
                v-model="form.coletaDataFim"
                class="form-control"
                :config="configFlatPickr"
                placeholder="Ex: 31/10/2026"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Cronograma dos Demais Desafios -->
        <b-row>
          <b-col
            cols="12"
            class="mt-1 mb-1"
          >
            <h6 class="text-secondary font-weight-bold">
              Período dos Demais Desafios (Exibição no App Mobile)
            </h6>
            <small class="text-muted">Defina os prazos exibidos nos cards da tela inicial do aplicativo para esta escola.</small>
          </b-col>

          <!-- Quiz -->
          <b-col md="6">
            <b-form-group
              label="Quiz - Início"
              label-for="quizDataInicio"
            >
              <flat-pickr
                id="quizDataInicio"
                v-model="form.quizDataInicio"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Quiz - Fim"
              label-for="quizDataFim"
            >
              <flat-pickr
                id="quizDataFim"
                v-model="form.quizDataFim"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>

          <!-- Patrulha -->
          <b-col md="6">
            <b-form-group
              label="Patrulha - Início"
              label-for="patrulhaDataInicio"
            >
              <flat-pickr
                id="patrulhaDataInicio"
                v-model="form.patrulhaDataInicio"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Patrulha - Fim"
              label-for="patrulhaDataFim"
            >
              <flat-pickr
                id="patrulhaDataFim"
                v-model="form.patrulhaDataFim"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>

          <!-- Janela de Tanque -->
          <b-col md="6">
            <b-form-group
              label="Janela de Tanque - Início"
              label-for="janelaDataInicio"
            >
              <flat-pickr
                id="janelaDataInicio"
                v-model="form.janelaDataInicio"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Janela de Tanque - Fim"
              label-for="janelaDataFim"
            >
              <flat-pickr
                id="janelaDataFim"
                v-model="form.janelaDataFim"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>

          <!-- Arboturma -->
          <b-col md="6">
            <b-form-group
              label="Arboturma - Início"
              label-for="arboturmaDataInicio"
            >
              <flat-pickr
                id="arboturmaDataInicio"
                v-model="form.arboturmaDataInicio"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Arboturma - Fim"
              label-for="arboturmaDataFim"
            >
              <flat-pickr
                id="arboturmaDataFim"
                v-model="form.arboturmaDataFim"
                class="form-control"
                :config="configFlatPickr"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- social link -->
      <!-- <tab-content title="Turmas">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Social Links</h5>
            <small class="text-muted">Insira informações de turmas</small>
          </b-col>
        </b-row>
      </tab-content> -->
    </form-wizard>
  </div>
</template>

<script>
import schoolService from '@/services/schoolService'
import { hideSpinner, showSpinner } from '@/services/spinService'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  BCol, BFormGroup, BFormInput, BFormCheckbox, BRow, BButton, BBadge,
} from 'bootstrap-vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import 'flatpickr/dist/flatpickr.css'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BBadge,
    vSelect,
    flatPickr,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  props: ['id'],
  data() {
    return {
      configFlatPickr: {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y',
        locale: Portuguese,
      },
      selectedContry: 'select_value',
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      greOptions: [
        { value: null, text: 'Nenhuma GRE Selecionada' },
        { value: '61eb4207-d6ce-4b53-b3c0-373150de9816', text: 'GRE Sul' },
        { value: 'f925c7cc-cdcb-43de-a982-62c9c4a4118b', text: 'GRE Norte' },
      ],

      form: {
        id: null,
        name: null,
        email: null,
        greId: null, // Mock até criar GRE
        telephone: null,
        nameDirector: null,
        emailDirector: null,
        cpfDirector: null,
        cellPhoneDirector: null,
        address: null,
        neighborhood: null,
        postalCode: null,
        city: null,
        existePontoColeta: false,
        coletaAtiva: true,
        coletaDataInicio: null,
        coletaDataFim: null,
        quizDataInicio: null,
        quizDataFim: null,
        patrulhaDataInicio: null,
        patrulhaDataFim: null,
        janelaDataInicio: null,
        janelaDataFim: null,
        arboturmaDataInicio: null,
        arboturmaDataFim: null,
      },
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getSchoolInfo()
    }
  },
  methods: {
    async formSubmitted() {
      showSpinner()
      const greIdVal = this.form.greId
        ? (this.form.greId.value !== undefined ? this.form.greId.value : this.form.greId)
        : null

      const payload = {
        ...this.form,
        greId: greIdVal,
      }

      if (this.$route.params.id) {
        this.fetchedSchools = await schoolService
          .update(payload)
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Dados salvos com sucesso!',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.push('/EscolasLista')
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  'Erro ao salvar escola. Verifique os campos e tente novamente',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
          .finally(() => {
            hideSpinner()
          })
      } else {
        this.fetchedSchools = await schoolService
          .create(payload)
          .then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Dados salvos com sucesso!',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.push('/EscolasLista')
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  'Erro ao criar escola. Verifique os campos e tente novamente',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
          .finally(() => {
            hideSpinner()
          })
      }
    },
    formatarDataParaInput(val) {
      if (!val) return null
      if (typeof val === 'string' && val.length === 10 && !val.includes('T')) return val
      const d = new Date(val)
      if (isNaN(d.getTime())) return val
      const y = d.getUTCFullYear()
      const m = String(d.getUTCMonth() + 1).padStart(2, '0')
      const dia = String(d.getUTCDate()).padStart(2, '0')
      return `${y}-${m}-${dia}`
    },
    async getSchoolInfo() {
      try {
        const school = await schoolService.getById(this.$route.params.id)
        this.form = {
          ...this.form,
          ...school,
          coletaDataInicio: this.formatarDataParaInput(school.coletaDataInicio),
          coletaDataFim: this.formatarDataParaInput(school.coletaDataFim),
          quizDataInicio: this.formatarDataParaInput(school.quizDataInicio),
          quizDataFim: this.formatarDataParaInput(school.quizDataFim),
          patrulhaDataInicio: this.formatarDataParaInput(school.patrulhaDataInicio),
          patrulhaDataFim: this.formatarDataParaInput(school.patrulhaDataFim),
          janelaDataInicio: this.formatarDataParaInput(school.janelaDataInicio),
          janelaDataFim: this.formatarDataParaInput(school.janelaDataFim),
          arboturmaDataInicio: this.formatarDataParaInput(school.arboturmaDataInicio),
          arboturmaDataFim: this.formatarDataParaInput(school.arboturmaDataFim),
        }
        this.$nextTick(() => {
          if (this.$refs.wizard) {
            this.$refs.wizard.activateAll()
            if (this.$route.query.tab === 'desafios' || this.$route.query.tab === 'cronograma') {
              this.irParaCronograma()
            }
          }
        })
      } catch (error) {
        this.$bvToast.toast('Erro ao carregar Escola!', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        })
      }
    },
    irParaCronograma() {
      if (this.$refs.wizard) {
        this.$refs.wizard.activateAll()
        this.$refs.wizard.changeTab(this.$refs.wizard.activeTabIndex, 3)
      }
    },

  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.wizard-vertical .wizard-nav > li {
  cursor: pointer !important;
}
</style>
